import { fetchProjects } from "@/services/supabaseService";
import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardFooter, CardHeader } from "./ui/card";
import { ArrowRight, Tag } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import ProjectCard from "./ProjectCard";
import { useLocation } from "react-router-dom";

const Projects = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isProjectsPage = location.pathname === "/projects";
  const navigateToPage = (path: string) => {
    navigate(path);
  };

  const { data: projects = [] } = useQuery({
    queryKey: ["projects"],
    queryFn: fetchProjects,
  });

  return (
    <div id="projects" className="container max-w-6xl mx-auto py-20 px-6">
      <div className="animate-slide-down">
        <h2 className="text-4xl font-bold mb-2 text-teal">My Projects</h2>
        <p className="text-gray-400 mb-6 break-words">
          Here are some of my most recent projects.
        </p>
      </div>

      <div className={isProjectsPage ? "grid grid-cols-1 gap-6 mb-8" : "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8"}>
        {(isProjectsPage ? projects : projects.slice(0, 3))?.map((project, index) => (
          <ProjectCard
            key={project.id}
            project={{
              ...project,
              description: !isProjectsPage && project.description
                ? project.description.split(" ").slice(0, 15).join(" ") + (project.description.split(" ").length > 20 ? "..." : "")
                : project.description
            }}
            index={index}
            showHighlights={isProjectsPage}
          />
        ))}
      </div>

      {!isProjectsPage && (
        <div className="flex justify-center">
          <Button
            onClick={() => navigateToPage("/projects")}
            className="bg-teal hover:bg-teal-dark text-navy-dark flex items-center gap-2"
          >
            View More
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default Projects;
